/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { Loader } from '@zeeve-platform/loader-component';
import { Link } from 'react-router-dom';
import Urls from '../../utils/urls';

import { prefixPath } from '../../utils/helpers';
import Paginate from '../pagination/paginate';
import EndpointCard from '../common/cards/endpointCards';
import BreadCrumb from '../common/breadCrumb/BreadCrumbComponent';
import RightButtons from '../common/buttons/addButtonComponent';
import apiBackendInstance from '../../utils/axios';

export interface endpointDataInterface {
  type: string,
  id: string,
  name: string,
  protocolId?: string,
  workspaceId: string,
  frontendBaseSuburl: string,
  protocolName: string,
  createdAt?: string,
  plan: string,
  viewableLabels: { [keys:string]:string},

}

const AllEndpointBody = ({ theme }: { theme: string }) => {
  const [endpointData, setEndpointData] = useState<endpointDataInterface[]>([]);
  const loaderImageUrl = window.location.origin + prefixPath(`/img/${theme}/spin.svg`);
  const [renderPagination, setRenderPagination] = useState(false);
  const [endpointDataLength, setEndpointDataLength] = useState(0);
  const [showLoader, setShowLoader] = useState(true);

  async function getPage(offset: number, limit: number): Promise<boolean> {
    try {
      setShowLoader(true);
      const response = await apiBackendInstance.get(Urls.getAllEndpointList(offset, limit), {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      if (response && response.data && response.data.data && response.data.data.endpointList) {
        setEndpointData(response.data.data.endpointList);
        setShowLoader(false);
        return true;
      }
      console.log('didnt get  data right here is the response : ', response);
    } catch (error) {
      setShowLoader(false);
      setEndpointData([]);
      console.log(error);
    }
    return false;
  }
  useEffect(() => {
    let isActive = true;
    setShowLoader(true);
    apiBackendInstance.get(Urls.getAllEndpointList(0, 7), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (isActive && response && response.data && response.data.data && response.data.data.endpointList) {
        const { endpointList } = response.data.data;
        const endpointListCount = Number(response.data.data.totalEndpointCount);
        if (endpointListCount > 7) {
          setEndpointDataLength(endpointListCount);
          setRenderPagination(true);
        }
        setEndpointData(endpointList);
        setShowLoader(false);
      }
    }).catch((err) => {
      setEndpointData([]);
      setShowLoader(false);
      setRenderPagination(false);
      console.error(err);
    });
    return () => { isActive = false; };
  }, []);

  const imgSubPath = window.location.origin;
  const addIconImg = imgSubPath + prefixPath(`/img/${theme}/add-icon.png`);
  const toEndpointSubscriptions = prefixPath('/endpoint/subscriptions');
  localStorage.setItem('from', 'rpcEndpoint');

  return (
    <section className="px-5 col-12 workspace">
      { showLoader && <Loader imagePath={loaderImageUrl} />}
      <div className="cardBlack">
        <div className="row mt-4 pt-1">
          {/* <span className="row mt-4 pt-1">RPC Endpoint</span> */}
          <BreadCrumb breadcrumbURI="RPC Endpoint" />
          <div className="col-lg-6 col-xl-6 col-sm-12 col-xs-12 cursor button-add">
            <div className="d-flex justify-content-end">
              <RightButtons theme={theme} name="Add RPC Endpoint" path={toEndpointSubscriptions} />
            </div>
          </div>
          <div className="mt-2 row">
            {
              endpointData.map((o, idx) => (
                <EndpointCard
                  cardnumber={idx}
                  total={endpointData.length}
                  key={o.id}
                  type={o.type}
                  id={o.id}
                  name={o.name}
                  protocolId={o.protocolId}
                  plan={o.plan}
                  viewableLabels={o.viewableLabels}
                  workspaceId={o.workspaceId}
                  frontendBaseSuburl={o.frontendBaseSuburl}
                  protocolName={o.protocolName}
                  createdAt={o.createdAt}
                />
              ))
            }
            <div className="col-lg-4 col-xl-3 col-md-5 col-sm-12 mt-5 cursor mg-auto">
              <div className="workSpaceCard cursor ">
                <Link to={toEndpointSubscriptions} style={{ textDecoration: 'none' }}>
                  <div className="card-body text-center add-workspace">
                    <div className="mt-4 mx-auto">
                      <img className="mt-2 mb-3" src={addIconImg} alt="" />
                    </div>
                    <h6 className="mt-2 activeTextColor">New RPC Endpoint</h6>
                    <p>
                    Deploy Your Endpoint and Make a Request
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Paginate totalItems={endpointDataLength} itemsPerPage={7} renderPagination={renderPagination} getPage={getPage} pageLimit={7} />
    </section>
  );
};

export default AllEndpointBody;
